import {  Container, Modal, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { removePromotionsPromocode } from "../../redux/actions/cartAction";

function Offers({ show, handleClose, promotions, loginData, handleApplyPromocode, cart, removePromotionsPromocode }) {
  return (
    <Modal show={show} onHide={handleClose} size="lg" centered dialogClassName="custom-dialog" contentClassName="custom-content">
      <Modal.Body>
        <Container className="offer-container" >
          <Row className=" p-3 mt-2" style={{ background: "#848484" }}>
            <div className="d-flex justify-content-between align-items-center w-100 mb-3">
              <h3 className="m-0 font-weight-bold text-light">Offer For You</h3>
              <p
                role="button"
                className="shadow p-2 bg-white rounded-circle"
                onClick={handleClose}
                style={{ background: "#F5F5F5" }}
              >
                <img src="/assets/close.svg" alt="close" />
              </p>
            </div>
          </Row>
          {/* <Row className="p-3 mt-2" style={{ background: "#848484" }}>
            <Col lg={12} className="px-0 d-flex justify-content-between">
              <div
                className="font-weight-semi-bold text-white"
                style={{ fontSize: "17px" }}
              >
                Offers for You
              </div>
            </Col>
          </Row> */}
          {promotions.map((promo) => (
            <Row
              className="px-0 py-3 align-items-center justify-content-between w-100 m-0"
              style={{ borderBottom: "1px dashed #C5C5C5" }}
            >
              <div className="d-flex align-items-center">
                <img src="/assets/discount.svg" alt="discount" height={60} className="mr-2" />
                <div>
                  <h6 className="m-0 font-weight-bold">{promo.Name}</h6>
                  {/* <h6 title={promo.Name} className="m-0 font-weight-normal">{isMobile ? promo.Name?.length > 22 ? promo.Name.substring(0, 22) + "..." : promo.Name : promo.Name}</h6> */}
                  {/* <small>abc</small> */}
                </div>
              </div>

              {/* {loginData.userAuth ? ( */}
              {cart.appliedPromotions && cart.appliedPromotions?.promotions
                && cart.appliedPromotions?.promotions[0].Id == promo.Id ?
                <h6 h6
                  className="m-0 font-weight-semi-bold"
                  role="button"
                  style={{ color: "#969696" }}
                  onClick={() => removePromotionsPromocode()}
                >
                  Applied
                </h6> :
                <h6
                  className="m-0 font-weight-semi-bold"
                  role="button"
                  onClick={() => handleApplyPromocode(promo.Code)}
                >
                  Apply
                </h6>}
              {/* ) : (
                <Link href="#top">
                  <h6
                    className="m-0 font-weight-semi-bold"
                    role="button"
                    onClick={() => {
                      handleClose();
                      toast.error("Login to Apply");
                    }}
                  >
                    Login to Apply
                  </h6>
                </Link> */}
              {/* )} */}
            </Row>
          ))}
          {/* <Row className="p-3 mt-2" style={{ background: "#de1414" }}>
            <Col lg={12} className="px-0 d-flex justify-content-between align-items-center">
              <div
                className="font-weight-semi-bold text-white"
                style={{ fontSize: "17px" }}
              >
                LevelUp Subscription
              </div>
              <button className="upgrade-btn">
              Add
              </button>
            </Col>
          </Row> */}
          {/* {promotions.map((promo) => (
            <Row
              className="px-0 py-3 align-items-center justify-content-between w-100 m-0"
              style={{ borderBottom: "1px dashed #C5C5C5" }}
            >
              <div className="d-flex align-items-center">
                <img src="/assets/discount.svg" height={60} className="mr-2" />
                <div>
                  <h6 className="m-0 font-weight-bold">{promo.Name}</h6>
                  <small>abc</small>
                </div>
              </div>

              {loginData.userAuth ? (
                <h6
                  className="m-0 font-weight-semi-bold"
                  role="button"
                  onClick={() => applyOffer(promo)}
                >
                  Apply
                </h6>
              ) : (
                <Link href="#top">
                  <h6
                    className="m-0 font-weight-semi-bold"
                    role="button"
                    onClick={() => {
                      handleClose();
                      toast.error("Login to Apply");
                    }}
                  >
                    Login to Apply
                  </h6>
                </Link>
              )}
            </Row>
          ))} */}
        </Container>
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    loginData: state.loginData,
    cart: state.cart
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    removePromotionsPromocode: () => {
      dispatch(removePromotionsPromocode());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Offers);
